import React, {useMemo, useEffect} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table, Icon, Popup} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import TablePaginator from '../common/TablePaginator';
import {Link} from 'react-router-dom';
const columnsTableWithProps = () => {
  return [
    {
      'Header': 'CÓDIGO',
      'accessor': 'code',
    },
    {
      'Header': 'SFX',
      'accessor': 'sfx',
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'katashiki',
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': 'USUARIO CREACIÓN',
      'accessor': 'creationUser',
    },
    {
      'Header': 'ESTADO',
      'accessor': 'state',
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'disableFilters': true,
      'Cell': ({row}) => {
        const {code} = row.original;
        return (
          <>
            <Popup
              trigger={
                <Link to={`/maestro-vehiculos/editar/${code}`}>
                  <Icon name='write' color='blue' size='large' />
                </Link>
              }
              content='Editar'
              position='top center'
              inverted
            />
          </>
        );
      },
    },
  ];
};
const VehicleListTable = ({dataTable, handleChange, countRows}) => {
  const columnsTable = columnsTableWithProps();
  const data = useMemo(() => dataTable, []);
  const columns = useMemo(() => columnsTable, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    rows,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 20},
    },
    useFilters,
    usePagination,
    useRowSelect,
  );
  useEffect(() => {
    if (rows.length !== countRows) {
      handleChange('countRows', rows.length);
    }
  }, [rows]);
  return (
    <>
      <div className='table-container'>
        <Table
          className='interactive'
          compact
          striped
          {...getTableProps()}
        >
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center'>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};
export default VehicleListTable;
